import '../css/style.scss';

window.onload = function() {

    for(var i=0; i < model.pricing.length; i++) {
        let price = model.pricing[i];
        $('.cards').append('<div id="card-' + price.id + '" class="card"><h1></h1><div class="scroll"><img src="" /><p></p><div class="rows"></div><div class="price"></div></div></div>');
        let card = $('#card-' + price.id).children('div');
        card.parent().children('h1').text(price.title);
        card.children('img').attr('src', price.image);
        card.children('p').text(price.text);
        card.children('.price').text(price.price);
        for(var l=0; l < price.items.length; l++) {
            let item = price.items[l];
            let row = $('<div class="row head' + (l==price.items.length-1 ? ' last' : '') + '" link="row-' + price.id + l + '"><div class="col l"><img class="icon" src="img/expand.svg"></div></div>');
            for(var m=0; m < item.cols.length; m++) {
                let col = item.cols[m];
                if(row.children().length == 1) {
                    row.append('<div class="col t">' + col + '</div>');
                } else {
                    row.append('<div class="col r">' + col + '</div>');
                }
            }
            card.children('.rows').append(row);

            for(var o=0; o < item.items.length; o++) {
                let child = item.items[o];
                let row = $('<div class="row descript row-' + price.id  + l + '"><div class="col l"></div></div>');
                for(var p=0; p < child.cols.length; p++) {
                    let col = child.cols[p];
                    if(row.children().length == 1) {
                        row.append('<div class="col t">' + col + '</div>');
                    } else {
                        row.append('<div class="col r">' + col + '</div>');
                    }
                }
                row.css('display', 'none');
                card.children('.rows').append(row);
            }
        }
    }

    $('.row').on('click', function(){
        let isExpanded = $(this).hasClass("expanded");
        let link = $(this).attr("link");
        let dfiff = $(this).parent().parent().height() - $(this).parent().parent().parent().height();
        if(isExpanded) {
            $("." + link).css("display", "none");
            $(this).children(".col").children(".icon").attr("src", "img/expand.svg");
            let v = ($(this).parent().parent().height() - $(this).parent().parent().parent().height()) - dfiff;
            $(this).parent().parent().animate({"top": "-=" + v + "px"});
            $(this).removeClass("expanded");
        } else {
            $("." + link).css("display", "flex");
            $(this).children(".col").children(".icon").attr("src", "img/minus.svg");
            let v = dfiff - ($(this).parent().parent().height() - $(this).parent().parent().parent().height());
            $(this).parent().parent().animate({"top": "+=" + v + "px"});
            $(this).addClass("expanded");
        }
    });

    $('.inquiry').on('click', function(){
        $("html,body").animate({scrollTop:$('#contact').offset().top});
    });

    $('.annofab').on('click', function(){
        window.open("https://annofab.com/", '_blank');
        return false;
    });

    $('footer').on('click', function(){
        window.open("https://kurusugawa.jp/", '_blank');
        return false;
    });

    $('.campaign > .close').on('click', function(){
        $('.campaign').css('visibility','hidden');
    });

    $('.logo > img').on('mouseover', function(){
        $(this).attr('src', 'img/logo_hover.svg');
    });

    $('.logo > img').on('mouseout', function(){
        $(this).attr('src', 'img/logo.svg');
    });
    

    $("#form-inquiry-submit").on("click", function(event){
        if($("#form-inquiry")[0].checkValidity()) {
            var json = {
                email: document.form_inquiry.email.value,
                message: document.form_inquiry.message.value,
                tel: document.form_inquiry.phone.value,
                company: document.form_inquiry.company.value,
                name: document.form_inquiry.uname.value,
            };

            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                var READYSTATE_COMPLETED = 4;
                var HTTP_STATUS_OK = 200;

                if(this.readyState == READYSTATE_COMPLETED)　{
                    if(this.status == HTTP_STATUS_OK) {
                        alert(
                              "お問い合わせありがとうございます。" + "\n"
                            + "お客様のお問い合わせを受け付けたことをお客様のメールアドレスへお送りさせて頂きました。" + "\n"
                            + "近日中に回答させて頂きますので、しばらくお待ちください。" + "\n"
                        );
                        gtag_report_conversion("https://annofab.com/annotation/#form-inquiry");
                    } else {
                        alert("お問い合わせに失敗しました。時間をおいて再度お試しください。");
                    }
                }
            };

            xhr.open("PUT", "https://jb6zr3dkxi.execute-api.ap-northeast-1.amazonaws.com/s2/contactlp", true);
            xhr.send(JSON.stringify(json));

            return false;
        } else {
            return true;
        }
    });
}
